import StaticPage from "./StaticPage";

const content = {
  en: {
    title: "Disclaimer",
    subtitle: "Important notes about the use of FileNesto's tools and content.",
    description: "FileNesto Disclaimer: information about service accuracy, third-party links, advertising, and limitations of use.",
    lastUpdated: "February 2026",
    sections: [
      {
        h2: "1. General information only",
        body: "The information and tools provided on FileNesto are intended for general informational and productivity purposes only. While we make every effort to keep the tools accurate, fast, and reliable, FileNesto makes no representations or warranties about the completeness, accuracy, or suitability of the Service for any specific purpose.",
      },
      {
        h2: "2. No professional advice",
        body: "FileNesto does not provide legal, financial, medical, or any other professional advice. The output of our tools (such as extracted text, converted documents, or compressed files) should not be relied upon as a substitute for the original document or professional review when accuracy is critical.",
      },
      {
        h2: "3. Tool output and accuracy",
        body: "File processing tools work best on well-formed documents. Results may vary depending on the structure, formatting, and quality of the input file. We strongly encourage you to verify the output before relying on it for important decisions, signatures, or legal use.",
      },
      {
        h2: "4. External links",
        body: "FileNesto may contain links to external websites that are not operated by us. We have no control over the content, privacy policies, or practices of any third-party sites and accept no responsibility for them.",
      },
      {
        h2: "5. Advertising",
        body: "Some pages on FileNesto may display advertisements from third-party networks such as Google AdSense. The presence of an advertisement does not imply endorsement, and we are not responsible for the content of advertisements or the products or services they promote.",
      },
      {
        h2: "6. No file storage",
        body: "FileNesto does not store the files you upload. Files are processed in memory and discarded immediately after the response is sent. You are responsible for keeping your own backup of the original document.",
      },
      {
        h2: "7. Limitation of liability",
        body: "Under no circumstances shall FileNesto be liable for any loss or damage of any kind incurred as a result of the use of the Service or reliance on any information or output provided. Use of the Service is at your own risk.",
      },
      {
        h2: "8. Updates",
        body: "We may update this Disclaimer from time to time. Please review it periodically for any changes.",
      },
      {
        h2: "9. Contact",
        body: "Questions about this Disclaimer can be sent to contact@filenesto.com.",
      },
    ],
  },
  fr: {
    title: "Avertissement",
    subtitle: "Notes importantes concernant l'utilisation des outils et du contenu FileNesto.",
    description: "Avertissement FileNesto : informations sur la précision du service, les liens tiers, la publicité et les limitations d'usage.",
    lastUpdated: "Février 2026",
    sections: [
      {
        h2: "1. Informations à titre général",
        body: "Les informations et outils proposés sur FileNesto sont destinés à un usage informatif et de productivité général uniquement. Bien que nous fassions tout pour maintenir les outils précis, rapides et fiables, FileNesto ne formule aucune garantie sur l'exhaustivité, l'exactitude ou l'adéquation du Service à un objectif spécifique.",
      },
      {
        h2: "2. Pas de conseil professionnel",
        body: "FileNesto ne fournit aucun conseil juridique, financier, médical ou autre conseil professionnel. Les résultats de nos outils (texte extrait, documents convertis, fichiers compressés) ne doivent pas remplacer le document original ou une revue professionnelle lorsque l'exactitude est critique.",
      },
      {
        h2: "3. Résultats et exactitude",
        body: "Les outils fonctionnent au mieux sur des documents bien formés. Les résultats peuvent varier selon la structure, la mise en forme et la qualité du fichier d'entrée. Nous vous encourageons fortement à vérifier le résultat avant de vous y fier pour des décisions importantes, des signatures ou un usage juridique.",
      },
      {
        h2: "4. Liens externes",
        body: "FileNesto peut contenir des liens vers des sites externes que nous n'exploitons pas. Nous n'avons aucun contrôle sur le contenu, les politiques de confidentialité ou les pratiques de ces sites tiers et n'en assumons aucune responsabilité.",
      },
      {
        h2: "5. Publicité",
        body: "Certaines pages FileNesto peuvent afficher des publicités de réseaux tiers tels que Google AdSense. La présence d'une publicité n'implique aucune approbation, et nous ne sommes pas responsables du contenu des publicités ni des produits ou services promus.",
      },
      {
        h2: "6. Aucun stockage de fichiers",
        body: "FileNesto ne stocke pas les fichiers que vous uploadez. Les fichiers sont traités en mémoire et supprimés immédiatement après l'envoi de la réponse. Vous êtes responsable de la sauvegarde de votre document original.",
      },
      {
        h2: "7. Limitation de responsabilité",
        body: "En aucun cas FileNesto ne pourra être tenu responsable de toute perte ou dommage résultant de l'utilisation du Service ou de la confiance accordée aux informations ou résultats fournis. L'utilisation du Service se fait à vos propres risques.",
      },
      {
        h2: "8. Mises à jour",
        body: "Nous pouvons mettre à jour cet Avertissement de temps à autre. Merci de le consulter régulièrement.",
      },
      {
        h2: "9. Contact",
        body: "Toute question concernant cet Avertissement peut être adressée à contact@filenesto.com.",
      },
    ],
  },
};

export default function Disclaimer() {
  return <StaticPage content={content} slug="/disclaimer" testid="page-disclaimer" />;
}
